import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    checkbox1,
    checkbox2,
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId,
    contract,
    checkbox3,
    checkbox4,
    taxId2,
    moneyType,
    projectType,

    fullName,
    certificate,
    signer,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [contract.name]: Yup.string().optional(),
  [checkbox1.name]: Yup.string().optional(),
  [checkbox2.name]: Yup.string().optional(),
  [checkbox3.name]: Yup.string().optional(),
  [checkbox4.name]: Yup.string().optional(),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [moneyType.name]: Yup.string().required(moneyType.errorMsg),
  [projectType.name]: Yup.string().required(projectType.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [taxId2.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId2.invalidMsg)
    .required(taxId2.errorMsg),

  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
});

export default validation;
